import React from "react";
import { Button, DeleteIcon } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import s from "~/pages/BaseStaff/EmployeeProfileEditor/EmployeeProfileForm/EmployeeProfileForm.less";

interface IPositionHeaderProps {
  title: string;
  onRemove?: () => void;
}

const PositionHeader = ({ title, onRemove }: IPositionHeaderProps) => {
  const { t } = useTranslation();

  if (!onRemove) {
    return <div className={s.positionTitle}>{title}</div>;
  }

  return (
    <div className={s.positionHeader}>
      <Button
        variant="text"
        color="secondary"
        size="small"
        htmlType="button"
        icon={<DeleteIcon size={16} />}
        aria-label={t("ui.delete")}
        title={t("ui.delete")}
        onClick={onRemove}
      />
      <div className={s.positionTitle}>{title}</div>
    </div>
  );
};

export default PositionHeader;
